import React from 'react';
import { connect } from 'react-redux';
import { getSales, getSalesPaginated } from "../../api/saleapi";
import SearchBar from '../SearchBar';
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleDropDownClick, formatDateFields } from '../../helpers';
import { updateRedirect } from './../../helpers/redirect';
import '../css/View.css';
import ReportTypes from '../reports/reportTypes'
import DataTableBase from '../utils/DataTable';

class SaleView extends React.Component {
    constructor(props) {
        super(props);
        let filterValue = '';
        if (this.props.route.location.state)
            filterValue = this.props.location.state.saleFilter;
        this.table = React.createRef();

        this.state = {
            data: [],
            sales: [],
            expanded: {},
            sale: {},
            loading: true,
            value: filterValue,
            edit: false,
            create: false,
            dropdownOpen: false,
            branchAmount: 0,
            moreOptions: [],
            openStyle: false,
            searches: false,
            redirectToReport: false,
            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }
        this.filterSearch = this.filterSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.toggle = this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.stateSettingClosed = this.stateSettingClosed.bind(this);
        this.redirectDropdown = this.redirectDropdown.bind(this);
        this.stateSettingOpened = this.stateSettingOpened.bind(this);
        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    componentDidMount() {
        this.setState({
            loading: true,
        })
        this.fetchData(this.state.value, 0)
    }

    handleEdit(sale) {
        this.setState({
            edit: true,
            saleId: sale.saleId
        })
    }

    handleCreate() {
        this.setState({
            create: true
        })
    }


    //Parent setting state to pass as props to child function for dropdown
    stateSettingClosed(moreOpts) {
        this.setState({
            moreOptions: moreOpts,
            openStyle: false
        })
    }

    //Parent setting state to pass as props to child function for dropdown
    stateSettingOpened(moreOpts) {
        this.setState({
            moreOptions: moreOpts,
            openStyle: true
        })
    }

    redirectDropdown(item, saleId) {
        switch (item) {
            case "Gifts":
                var route = <Redirect
                    to={{
                        pathname: `/secure/gifts`,
                        state: { saleId: saleId, from: 'sales' }
                    }} />;
                break;
        }

        this.setState({
            dropdownClicked: true,
            route: route,
        })
    }

    filterSearch(event) {
        var value = event.target.value;
        if ((event.key === 'Enter' && value) || (!value)) {
            this.fetchData(value, 0);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    getData(data, _this) {
        if (data.data.data) {
            var length = data.data.data.length;
            var p = <p className="cursor closed">
                <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
            </p>;
            var moreOptions = [];
            for (let x = 0; x < length; x++) {
                moreOptions.push(p)
            }
            _this.setState({
                sales: data.data.data,
                moreOptions: moreOptions,
                loading: false
            })
        }
        else {
            _this.setState({
                sales: [],
                moreOptions: [],
                loading: false
            })
        }
    }

    fetchData(filterValue, page) {
        var p = <p className="cursor closed" >
            <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
        </p>;
        if (typeof filterValue === 'object')
            filterValue = this.state.value;
        if (page === undefined)
            page = this.state.page;
        if (page !== 0)
            page = page - 1;
        this.setState({ loading: true, error: false });

        getSalesPaginated(filterValue, page, this.state.perPage, this.state.orderBy, this.state.descending)
            .then((res) => {
                var moreOptions = [];
                for (let x = 0; x < res.data.data.results.length; x++) {
                    moreOptions.push(p)
                }
                this.setState({
                    data: res.data.data.results,
                    pages: res.data.data.pageCount,
                    totalRows: res.data.data.rowCount,
                    moreOptions: moreOptions,
                    loading: false
                })
            }).catch((err) => {
                var errorList = [];
                err.response.data.errors.map(function (e) { errorList.push(e.message) });

                this.setState({
                    data: [],
                    error: true,
                    loading: false,
                    errorMessage: errorList
                })
            });
    }


    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page)
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value, 0)
            this.isSorting = false;
        });
    }

    render() {
        ///All variables and constants for rendering///

        //This style will make the clubcode border-right dissapear for dropdown UX consistency
        var style = this.state.openStyle ? { textAlign: "left", borderRight: 'none' }
            : { textAlign: "left" }

        //List of items to pass to the dropdown as <a>
        let items = ["Gifts"];

        //Name of component to pass to the dropdown to indentify dropdown className
        var component = "sales"

        if (this.state.redirectToReport)
            return <Redirect
                to={{
                    pathname: '/secure/sale/report',
                    state: { report: ReportTypes.SalesReport }
                }}
                push={true} />

        if (this.state.edit) {
            return <Redirect
                to={{
                    pathname: `/secure/saleEdit/${this.state.saleId}`,
                    state: { from: 'view' }
                }}
            />;
        }

        if (this.state.dropdownClicked) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: "gifts",
                selectedAdmin: ''
            });
            return this.state.route;
        }

        const columns = [
            {
                name:
                    <div
                        style={{
                            textAlign: 'left',
                            textIndent: 10,
                        }}
                    >
                        Donor Last Name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '250px',
                selector: row => row.lastName,
                sortable: true,
                sortField: 'lastName',
                cell: row => (
                    <div onClick={() => this.handleEdit(row)}>
                        <p style={{ marginLeft: '10px' }} className="cursor">
                            {row.lastName}
                        </p>
                    </div>
                ),
            },
            {
                name:
                    <div
                        style={{
                            textAlign: 'left',
                            textIndent: 10,
                        }}
                    >
                        Donor First Name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '275px',
                selector: row => row.firstName,
                sortable: true,
                sortField: 'firstName',
                cell: row => (
                    <div onClick={() => this.handleEdit(row)}>
                        <p style={{ marginLeft: '10px' }} className="cursor">
                            {row.firstName}
                        </p>
                    </div>
                ),
            },
            {
                name:
                    <div
                        style={{
                            textAlign: 'left',
                            textIndent: 10,
                        }}
                    >
                        Donor Email <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '275px',
                selector: row => row.email,
                sortable: true,
                sortField: 'email',
                cell: row => (
                    <div onClick={() => this.handleEdit(row)}>
                        <p style={{ marginLeft: '10px' }} className="cursor">
                            {row.email}
                        </p>
                    </div>
                ),
            },
            {
                name:
                    <div
                        style={{
                            textAlign: 'left',
                            textIndent: 10,
                        }}
                    >
                        Sales Date <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                selector: row => row.saleDate,
                sortable: true,
                sortField: 'saleDate',
                cell: row => (
                    <div onClick={() => this.handleEdit(row)}>
                        <p style={{ marginLeft: '10px' }} className="cursor">
                            {!row.saleDate ? "" : formatDateFields(row.saleDate)}
                        </p>
                    </div>
                ),
            },
            {
                //options header
                name:
                    <div
                        style={{
                            textAlign: 'center',
                        }}
                    >
                        Options
                    </div>,
                center: true,
                style: { justifyContent: 'center' },
                width: '100px',
                //options row
                cell: (row, index, column) => (
                    <div
                        onClick={ev =>
                            handleDropDownClick(
                                ev,
                                index,
                                this.state.moreOptions,
                                this.stateSettingClosed,
                                this.stateSettingOpened,
                                items,
                                component,
                                this.redirectDropdown,
                                row.saleId
                            )
                        }
                    >
                        {this.state.moreOptions[index]}
                    </div>
                ),
            },]
        return (
            <div >

                <SearchBar
                    onKeyUp={this.filterSearch}
                    onClick={this.filterSearch}
                    onChange={this.filterSearch}
                    value={this.state.value}
                />
                <DataTableBase
                    columns={columns}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.perPage}
                    paginationDefaultPage={this.state.defaultPage}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    onSort={this.handleSort}
                />

                <button onClick={() => this.setState({ redirectToReport: true })} className="btn mt-4">Reports</button>
            </div>
        );
    }
}

export default
    connect(
        state => {
            return {
                sales: state.data.sales
            }
        },
        dispatch => ({
            getSales: (callback, conext, filter) => { dispatch(getSales(callback, conext, filter)) },
            currentNavigationConnect: (response) => { dispatch(updateRedirect(response)) }
        }))
        (SaleView);
